module.exports = __webpack_public_path__ + "img/1_1-stazione_carburante-1-fotovoltaico.7f9f5dfc.png";